import Chip, { ChipProps } from '@mui/material/Chip'
import { styled } from '@mui/material/styles'
import { colors } from 'styles/theme'

export type TagColor = 'error' | 'info' | 'success' | 'warning' | 'default'

type Props = ChipProps & {
  color?: TagColor
}

const Tag = (props: Props) => {
  const { color = 'default', ...chipProps } = props
  return <StyledChip {...chipProps} color={color} />
}

function setColor(status) {
  switch (status) {
    case 'success':
      return { back: colors.green[0], color: colors.green[600] }
    case 'error':
      return { back: colors.red[0], color: colors.red[600] }
    case 'warning':
      return { back: colors.yellow[0], color: colors.yellow[600] }
    case 'info':
      return { back: colors.purple[0], color: colors.purple[600] }
    case 'default':
      return { back: colors.gray[100], color: colors.gray[700] }
  }
}

const StyledChip = styled(Chip)<ChipProps>`
  color: ${({ color }) => setColor(color).color};
  background-color: ${({ color }) => setColor(color).back};
`

export default Tag
